import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ModelSelect/SelectItem/SelectItem.styled.ts",
    _templateObject,
    _templateObject2,
    _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import makeStyles from '@mui/styles/makeStyles';
export var useStyles = makeStyles({
  listItemSecondaryAction: {
    right: '12px'
  }
});
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  user-select: none;\n  cursor: ", ";\n  padding: ", ";\n  background: ", ";\n  ", "\n\n  &:last-child {\n    ", "\n  }\n\n  &:hover {\n    background: ", ";\n  }\n"])), function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.isChild ? '10px 48px 10px 35px' : '10px 52px 10px 12px';
}, function (props) {
  return props.active ? 'rgba(92, 130, 229, 0.15)' : 'inherit';
}, function (props) {
  return props.disabled && 'opacity: 0.3; pointer-events: none;';
}, function (props) {
  return props.isChild && 'margin-bottom: 5px;';
}, function (props) {
  return props.active ? 'linear-gradient(rgba(53, 59, 96, 0.05), rgba(53, 59, 96, 0.05)), linear-gradient(rgba(92, 130, 229, 0.15), rgba(92, 130, 229, 0.15))' : 'rgba(53, 59, 96, 0.05)';
});
export var SelectedDot = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: rgba(125, 177, 255, 0.5);\n  width: 8px;\n  height: 8px;\n  border-radius: 4px;\n"])));
export var SelectItemText = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: #353b60;\n  font-size: 14px;\n  line-height: 21px;\n  font-weight: 500;\n  font-family: Roboto, sans-serif;\n"])));